module.exports = __webpack_public_path__ + "img/Communications.efa861de.png";